import { EventTypeEnum } from '../../../dto/recs.dto';
import { Event } from '../event';

export class BackendEvent extends Event {
  public constructor (
    private readonly adSlotIdentifier: string,
    private readonly type: EventTypeEnum,
    private readonly payload?: Record<string, unknown>,
  ) {
    super();
  }

  public getAdSlotIdentifier (): string {
    return this.adSlotIdentifier;
  }

  public getType (): EventTypeEnum {
    return this.type;
  }

  public getPayload (): Record<string, unknown> | undefined {
    return this.payload;
  }
}
